export enum Bucket {
    One = 'one',
    Two = 'two',
}

export enum QuestionType {
    Percentage = 'percentage',
    Numeric = 'numeric',
    Boolean = 'boolean',
    SingleChoice = 'singleChoice',
}

export enum BooleanDisplayFormat {
    YesNo = 'yesNo',
    TrueFalse = 'trueFalse',
}

export enum AudioType {
    Correct = 'correct',
    Incorrect = 'incorrect',
    Underestimated = 'underestimated',
    Overestimated = 'overestimated',
}

export enum QuizUserStatus {
    Completed = 'completed',
    Todo = 'todo',
    Blocked = 'blocked',
}
